export enum Alignment {
  Left,
  Center,
  Right
}
